import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import useProductCardLayout from '../hooks/useProductCardLayout';


function ProductCardDetails({ details, children }) {
    const measurements = useProductCardLayout();
    const detailOffset = measurements.topRightHeight - measurements.nameHeight;

    return (
        /* CSS styling for all elements except for the outer Container are provided by ProductCardLayout */
        <Container
            className="row-reverse rh-display-flex rh-flex-wrap-reverse"
            $detailOffset={detailOffset}
        >
            <div className="details-wrapper">
                {details}
            </div>

            <div className="right-hand-side-wrapper rh-pb-1">
                {/* we always need div.right-hand-side-wrapper, and it should remain even when there are no children */}
                {children}
            </div>
        </Container>
    );
}

ProductCardDetails.propTypes = {
    details: PropTypes.node.isRequired,
    children: PropTypes.node,
};


// just the detailOffset adjustments are here; all other styling in ProductCardLayout
const Container = styled.div`
    > .details-wrapper {
        ${({ $detailOffset }) => $detailOffset > 0 && `
            margin-top: -${$detailOffset}px;
        `};
    }

    > .right-hand-side-wrapper {
        ${({ $detailOffset }) => $detailOffset > 0 && `
            padding-bottom: calc(${$detailOffset}px + 1em);
        `};
    }
`;

export default ProductCardDetails;
